import React, { useContext } from "react";
import "./styles.scss";
import { ProductContext } from "../../../context/product-context/productContext";
import { ProductFamily } from "../../../context/product-context/product-family";

interface CountableStepProps {
  number: number;
  children: React.JSX.Element;
}

const CountableStep = ({ number, children }: CountableStepProps) => {
  const { selectedProduct } = useContext(ProductContext);

  return (
    <div className="countable-step--container scd-section-pusher-lg">
      <div
        className={`countable-step--number countable-step--${ProductFamily.getProductFamilyColor(
          selectedProduct.family,
        )}`}
      >
        <div className="test">{number}</div>
      </div>

      <div className="countable-step--content">{children}</div>
    </div>
  );
};

export default CountableStep;
